import React from 'react';
import { Title, Text, PageContainer } from 'components';
import { STATIC_SEO_WITH_DESCRIPTION } from 'graphql/queries/seo';
import { Helmet } from 'react-helmet';
import { useQuery } from '@apollo/react-hooks';
import { useHistory } from 'react-router-dom';
import { DescriptionWrapper } from './ConfidentialPolicy.style';

const ConfidentialPolicy = () => {
  const history = useHistory();

  const {
    loading: loadingLanding,
    error: errorLanding,
    data: dataSeo,
  } = useQuery(STATIC_SEO_WITH_DESCRIPTION, {
    variables: {
      url: `${history.location.pathname.slice(1)}`,
    },
    fetchPolicy: 'network-only',
  });

  React.useEffect(() => {
    console.log('dataSeo: ', history.location.pathname.slice(1));
    console.log('dataSeo: ', dataSeo);
  }, [dataSeo]);

  return (
    <>
      {dataSeo && (
        <Helmet>
          <title>{dataSeo.staticPage.seoMeta.seoTitle}</title>
          <meta
            name="description"
            content={dataSeo.staticPage.seoMeta.seoDescription}
          />
          <meta
            name="keywords"
            content={dataSeo.staticPage.seoMeta.seoKeywords}
          />
          <link rel="canonical" href="https://aktis.villas/en" />
        </Helmet>
      )}
      <PageContainer padding="50px 5.7vw 50px">
        <DescriptionWrapper>
          <div
            dangerouslySetInnerHTML={{
              __html: dataSeo ? dataSeo.staticPage.descr : null,
            }}
          />
        </DescriptionWrapper>
        <Title margin="0 0 30px 0" size="36px" sizeM="24px" weight="500" ubuntu>
          Политика конфиденциальности
        </Title>
        <Text size="16px">
          <Title
            margin="30px 0 20px 0"
            size="24px"
            sizeM="18px"
            weight="500"
            ubuntu
          >
            Политика использования cookie-файлов
          </Title>
          используются файлы cookie.
          <Title
            margin="30px 0 20px 0"
            size="24px"
            weight="500"
            sizeM="18px"
            ubuntu
          >
            Что такое cookie?
          </Title>
          Cookie-файлы - это файлы, которые загружаются на ваше устройство с
          веб-страниц. Это важный инструмент в поиске и предоставлении
          различного рода услуг в информационном сообществе. Давая свое
          согласие, вы разрешаете сайту использовать некоторую информацию об
          истории просмотра страниц и переходов, чтобы сайт имел возможность
          анализировать эти данные и предлагать вам максимально подходящие
          услуги и информацию.
        </Text>
      </PageContainer>
    </>
  );
};

export default ConfidentialPolicy;
